import { render, staticRenderFns } from "./students-ghiab-manual.vue?vue&type=template&id=28390c9c&"
import script from "./students-ghiab-manual.vue?vue&type=script&lang=js&"
export * from "./students-ghiab-manual.vue?vue&type=script&lang=js&"
import style0 from "./students-ghiab-manual.vue?vue&type=style&index=0&id=28390c9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports